/* NS product gallery: play the video when its thumbnail is selected, pause it when another item is selected.
   Motion V2 launch: swipe left/right on the main gallery frame (touch screens) to move to the next/previous item.
   Runs only on galleries that contain a video, so image-only product galleries are unchanged. */
(function () {
  'use strict';
  Array.prototype.slice.call(document.querySelectorAll('[data-product-gallery]')).forEach(function (gallery) {
    var main = gallery.querySelector('.product-gallery__main');
    if (!main) return;
    var wraps = Array.prototype.slice.call(main.querySelectorAll('.ns-pdp-video'));
    if (!wraps.length) return;
    gallery.addEventListener('click', function (e) {
      var thumb = e.target.closest('[data-thumb]');
      if (!thumb || !gallery.contains(thumb)) return;
      var id = thumb.getAttribute('data-thumb');
      wraps.forEach(function (wrap) {
        var isOn = wrap.getAttribute('data-media-id') === id;
        wrap.classList.toggle('is-active', isOn);
        var video = wrap.querySelector('video');
        if (!video) return;
        if (isOn) {
          var p = video.play();
          if (p && p.catch) p.catch(function () {});
        } else {
          video.pause();
        }
      });
    });

    /* Swipe between gallery items on touch screens. Selecting an item reuses the thumbnail click,
       so images, video playback and the active thumbnail all stay in sync with the existing behaviour.
       Swipes that start on the video's control bar (bottom 56px) are left to the player for scrubbing. */
    var thumbs = Array.prototype.slice.call(gallery.querySelectorAll('[data-thumb]'));
    if (thumbs.length < 2) return;
    var sx = 0, sy = 0, tracking = false;
    main.addEventListener('touchstart', function (e) {
      if (e.touches.length !== 1) { tracking = false; return; }
      var t = e.touches[0];
      var r = main.getBoundingClientRect();
      var onVideo = !!main.querySelector('.ns-pdp-video.is-active');
      tracking = !(onVideo && t.clientY > r.bottom - 56);
      sx = t.clientX; sy = t.clientY;
    }, { passive: true });
    main.addEventListener('touchend', function (e) {
      if (!tracking) return;
      tracking = false;
      var t = e.changedTouches[0];
      var dx = t.clientX - sx, dy = t.clientY - sy;
      if (Math.abs(dx) < 40 || Math.abs(dx) < Math.abs(dy) * 1.5) return;
      var cur = thumbs.findIndex(function (th) { return th.classList.contains('is-active'); });
      if (cur < 0) cur = 0;
      var next = cur + (dx < 0 ? 1 : -1);
      if (next < 0 || next >= thumbs.length) return;
      thumbs[next].click();
    }, { passive: true });
  });
})();
